import { usePageCapabilities } from "../../Shared/usePageCapabilities";

export function usePublishedDiscourseCapabilities(authenticatedUser) {
  const capabilities = {
    showAdminDiscourseNavigation: authenticatedUser?.canAdministerDocuments,
    showPublishedDiscourseNavigation: false,
    showYourDiscourseNavigation: authenticatedUser?.inDiscourseExperiment,
    showNewDiscourseNavigation: authenticatedUser?.inDiscourseExperiment,
  };

  usePageCapabilities(capabilities, []);
}